import { render, staticRenderFns } from "./ricercaGaranzie_clienti.vue?vue&type=template&id=614353ff&"
import script from "./ricercaGaranzie_clienti.vue.ts?vue&type=script&lang=ts&"
export * from "./ricercaGaranzie_clienti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports